import { FormProvider } from 'react-hook-form';
import { useEditPortalModal } from './hooks';
import { EditPortalFormFieldValues } from './logics/schema';
import { EditPortalModalPresentation } from './presentations';

type Props = {
  portalId: string;
  defaultValues: EditPortalFormFieldValues;
  defaultFileUrl?: string;
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};

export const EditPortalModal: React.FC<Props> = ({
  portalId,
  defaultValues,
  defaultFileUrl,
  isOpen,
  onClose,
  onSuccess,
}) => {
  const {
    state: { methods, selectedFile, existingFileUrl, hasFile },
    actions: { handleSubmit, handleFileChange, handleRemoveFile },
  } = useEditPortalModal({ portalId, defaultValues, defaultFileUrl, onClose, onSuccess });

  return (
    <FormProvider {...methods}>
      <EditPortalModalPresentation
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleSubmit}
        selectedFile={selectedFile}
        existingFileUrl={existingFileUrl}
        hasFile={hasFile}
        onFileChange={handleFileChange}
        onRemoveFile={handleRemoveFile}
      />
    </FormProvider>
  );
};
